module.exports = __webpack_public_path__ + "static/media/need-mental-health.53798ac2.jpg";